module.exports = __webpack_public_path__ + "img/background_7.7a380b87.jpg";